<template>
    <div
        class="modal fade"
        id="nomenclatureMassEditModal"
        role="dialog"
        aria-labelledby="nomenclatureMassEditModalLabel"
        backdrop="static"
        data-backdrop="static"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5
                        class="modal-title"
                        id="nomenclatureMassEditModalLabel"
                    >{{ $tc('administration.person.title', 2) }} / {{ $t('buttons.mergeSelected.btnText') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="loader" v-if="loading"></div>
                    <div v-else>
                        <div v-if="selectedPersons">
                            <PersonDetailsCard
                                v-for="(p) in sortedPersons"
                                :key="p.id"
                                :value="p"
                                :hideBtns="true"
                                :hideFooter="false"
                                :isAdministration="true"
                                :mergePerson="false"
                                :showSelectionCheckbox="true"
                                :selectionCheckboxLabel="$t('administration.person.isParent')"
                                @selected="onPersonSelected"
                            >
                                <template v-slot:actions>
                                    <div class="text-right">
                                        <button
                                            type="button"
                                            class="btn btn-danger"
                                            @click.stop="onPersonRemove(p)"
                                        >
                                            <i class="fas fa-ban mr-2"></i>
                                            {{ $t('buttons.remove.btnText')}}
                                        </button>
                                    </div>
                                </template>
                            </PersonDetailsCard>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" v-if="!loading">
                    <button class="btn btn-success" @click.stop="onSave" :disabled="saving">
                        <i v-if="saving" class="fas fa-spinner fa-spin"></i>
                        <i v-else class="fas fa-save mr-2"></i>
                        {{$t("buttons.save.btnText")}}
                    </button>
                    <button class="btn btn-danger" @click="hide" :disabled="saving">
                        <i class="fas fa-ban mr-2"></i>
                        {{$t("buttons.close")}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import personService from "../../../services/person.service";
import PersonDetailsCard from "../../../components/person/PersonDetailsCard";
import { Person } from "../../../models/models";

export default {
    components: { PersonDetailsCard },
    props: {
        selectedIds: [Number, Array],
        show: {
            type: Boolean,
            required: false,
        },
        grid: [Object],
    },
    data() {
        return {
            loading: false,
            saving: false,
            selectedPersons: [],
        };
    },
    methods: {
        load() {
            this.loading = true;

            personService
                .getByIds(this.selectedIds)
                .then((response) => {
                    let models = response.data;
                    if (models) {
                        this.cleareSelectedPersonsArr();

                        models.forEach((person) => {
                            this.selectedPersons.push(new Person(person));
                        });
                    }
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.loading = false;
                });
        },
        cleareSelectedPersonsArr() {
            if (
                Array.isArray(this.selectedPersons) &&
                this.selectedPersons.length > 0
            ) {
                while (this.selectedPersons.length > 0) {
                    this.selectedPersons.pop();
                }
            }
        },
        hide() {
            $(this.$el).modal("hide");
        },
        onClose() {
            this.$emit("onClose");
            this.$emit("update:show", false);
        },
        onSave() {
            const msgTitle = `${this.$tc('administration.person.title', 2)} / ${this.$t("buttons.mergeSelected.btnText")}`;
            if (!this.hasSelectedParent) {
                this.$vs.notify({
                    title: msgTitle,
                    text: this.$t("administration.person.noneParentSelected"),
                    color: "warning",
                    time: this.$store.getters.notificationDuration,
                });

                return;
            }

            this.saving = true;
            personService
                .merge(this.selectedPersons)
                .then((response) => {
                    this.$emit('save', this.grid);
                    this.$vs.notify({
                        title: msgTitle,
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: msgTitle,
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.saving = false;
                });
        },
        onPersonSelected(id) {
            const list = this.selectedPersons.filter((x) => x.id !== id);
            list.forEach((p) => {
                p.selected = false;
            });
        },
        onPersonRemove(p) {
            const indexToRemove = this.selectedPersons.findIndex(
                (x) => x.id === p.id
            );
            this.selectedPersons.splice(indexToRemove, 1);
            this.selectedPersons = this.selectedPersons.slice();
        },
    },
    mounted() {
        // add modal close listener
        $(this.$el).on("hidden.bs.modal", this.onClose);
    },
    beforeDestroy() {
        // remove listeners
        $(this.$el).off("hidden.bs.modal");
    },
    computed: {
        sortedPersons() {
            let data = this.selectedPersons;
            data = data.slice().sort((a, b) => {
                // true values first
                return a.selected === b.selected ? 0 : a.selected ? -1 : 1;
            });
            return data;
        },
        hasSelectedParent() {
            return this.selectedPersons.some((x) => x.selected === true);
        },
    },
    watch: {
        show: function (val) {
            if (val) {
                this.load();
            }

            $(this.$el).modal(val ? "show" : "hide");
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
